<template>
  <div class="_wrapper is-shop">
    <div class="block mt20">
      <shop-products-grid :columns="defaultColumn"
                          :products="getDiscountedProducts"
                          naming="Товари зі знижкою"
                          :counter="getTotalDiscountedProducts"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from 'theme/components/core/Breadcrumbs.vue'
import ShopProductsGrid from 'theme/components/core/blocks/Shop/Product/ProductsGrid'
import onBottomScroll from '@vue-storefront/core/mixins/onBottomScroll'

export default {
  name: 'DiscountedProducts',
  mixins: [onBottomScroll],
  components: {
    Breadcrumbs,
    ShopProductsGrid
  },
  // metaInfo() reads currentPartner on every render; App.vue's store watcher
  // doesn't fire for the initial route.
  async asyncData ({ store, route }) {
    if (!route.params.store) {
      return
    }
    await store.dispatch('partners/ensureCurrentPartner', { code: route.params.store, locationCode: route.params.locationCode })
  },
  computed: {
    ...mapGetters({
      getDiscountedProducts: 'category/getDiscountedProducts',
      getTotalDiscountedProducts: 'category/getTotalDiscountedProducts',
      currentPartner: 'partners/getCurrentPartner',
      locations: 'locations/getLocations'
    })
  },
  data () {
    return {
      defaultColumn: 4,
      pagination: {
        perPage: 50,
        current: 1
      },
      listLoading: true,
      sortOrder: 'sum_score:desc'
    }
  },
  mounted () {
    this.loadDiscountedProducts({
      location_code: this.currentPartner.location_code,
      partner_code: this.currentPartner.code,
      size: this.pagination.perPage,
      from: 0,
      sort: this.sortOrder
    })
      .finally(() => {
        this.listLoading = false
      })
    this.$bus.$on('list-change-sort', this.onSortOrderChanged)
  },
  methods: {
    ...mapActions({
      loadDiscountedProducts: 'category/loadDiscountedProducts'
    }),
    onSortOrderChanged (param) {
      this.listLoading = true
      this.pagination.current = 1
      this.loadDiscountedProducts({
        location_code: this.currentPartner.location_code,
        partner_code: this.currentPartner.code,
        size: this.pagination.perPage,
        from: 0,
        sort: param.attribute
      })
        .then(() => {
          this.sortOrder = param.attribute
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    onBottomScroll () {
      if (this.getDiscountedProducts.length >= this.getTotalDiscountedProducts) {
        return
      }
      this.pullMoreProducts()
    },
    pullMoreProducts () {
      this.listLoading = true
      this.loadDiscountedProducts({
        location_code: this.currentPartner.location_code,
        partner_code: this.currentPartner.code,
        size: this.pagination.perPage,
        from: this.pagination.current * this.pagination.perPage,
        sort: this.sortOrder
      })
        .then(() => {
          this.pagination.current++
        })
        .finally(() => {
          this.listLoading = false
        })
    }
  },
  beforeDestroy () {
    this.$bus.$off('list-change-sort', this.onSortOrderChanged)
  },
  metaInfo () {
    if (!this.currentPartner) {
      return {}
    }
    let location = this.locations.find(location => location.code === this.currentPartner.location_code)
    if (!location) {
      return {}
    }
    let title = `Доставка знижок з ${this.currentPartner.title} у м.${location.name}`
    let meta = [
      {
        vmid: 'description',
        name: 'description',
        content: `Хочете замовити товари онлайн за вигідними цінами з ${this.currentPartner.title}? Кур'єри Korzyna швидко привезуть замовлення до ваших дверей.`
      }
    ]
    return {
      title,
      meta
    }
  }
}
</script>
<style lang="scss" scoped>
._wrapper {
  width: 100%;

  &.is-shop {
    width: 850px;

    @media only screen and (max-width: 1200px) {
      width: 654px;
    }

    @media only screen and (max-width: 991px) {
      width: 722px;
    }

    @media only screen and (max-width: 768px) {
      width: 530px;
    }

    @media only screen and (max-width: 576px) {
      width: calc(100% - 30px);
      padding: 0 15px;
    }
  }
}

.block {
  width: 850px;

  @media only screen and (max-width: 1200px) {
    width: 654px;
  }

  @media only screen and (max-width: 991px) {
    width: 722px;
  }

  @media only screen and (max-width: 768px) {
    width: 530px;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
  }
}
.btn {
  &__filter {
    min-width: 100px;
  }
}
.divider {
  width: calc(100vw - 8px);
  bottom: 20px;
  left: -36px;
}
.category-filters {
  width: 242px;
  display: none;
  @media (max-width: 770px) {
    display: block;
  }
}

.mobile-filters {
  display: none;
  overflow: auto;
}

.mobile-filters-button {
  display: none;
}

.mobile-sorting {
  display: none;
}

.category-title {
  line-height: 65px;
}

.sorting {
  label {
    margin-right: 10px;
  }
}

.mobile-category-filter {
  display: none;
}

@media (max-width: 770px) {
  .category-title {
    margin: 0;
    font-size: 36px;
    line-height: 40px;
  }

  .products-list {
    max-width: 100%;
    flex-basis: 100%;
  }

  .mobile-filters {
    display: block;
  }

  .mobile-filters-button {
    display: block;
    height: 45px;
  }

  .sorting {
    display: none;
  }

  .mobile-sorting {
    display: block;
  }

  .category-filters {
    display: none;
  }

  .product-listing {
    justify-content: center;;
  }

  .mobile-filters {
    position: fixed;
    background-color: #F2F2F2;
    z-index: 5;
    padding: 0 40px;
    left: 0;
    width: 100vw;
    height: 100%;
    top: 0;
    box-sizing: border-box;
    border-bottom:2px solid #000
  }

  .mobile-filters-body {
    padding-top: 50px;
  }

  .mobile-category-filter {
    display: block;
  }
}

.close-container {
  left: 0;
}

.close {
  margin-left: auto;
}
.product{
  position: relative;
}
.view-more-categ{
  text-transform: uppercase;
  line-height: normal;
  font-family: 'TTNorms Light', sans-serif;
}
</style>
<style lang="scss">
.product{
  position: relative;
}
.product-image {
  max-height: unset !important;
}
</style>
